export const MENUS_DISPLAY_OPTIONS = {
  all: 'all',
  specific: 'specific',
};
